angular.module('app').factory('TeamAdminColumnDefs', () => {
    let columnDefs = [
        { headerName: 'Id', field: 'Id', width: 52, minWidth: 52, maxWidth: 52, suppressMovable: true, resizable: false, suppressMenu: true },
        { headerName: 'Team', field: 'Name', sort: 'asc', suppressMovable: true, cellRenderer: nameCellRenderer },
        { headerName: 'SupportId', field: 'SupportId', hide: true },
        { headerName: 'Members', field: 'NumMembers', suppressMenu: true, suppressMovable: true },
        { headerName: 'Projects', field: 'NumProjects', suppressMenu: true, suppressMovable: true },
        { headerName: 'Actions', cellRenderer: actionCellRenderer, minWidth: 120, maxWidth: 120, sortable: false, suppressMenu: true, resizable: false, suppressMovable: true }
    ];
    function createLink(data, tooltip, action) {
        let link = ['<span',
            'ng-if="!vm.state.linkFromName">',
            data,
            '</span><a ng-href=""',
            'class="space-top pointer"',
            'uib-popover="',
            tooltip,
            '"',
            'popover-animation',
            'popover-trigger="\'mouseenter\'"',
            'popover-placement="right"',
            'popover-append-to-body="true"',
            'ng-if="vm.state.linkFromName"',
            'ng-click="',
            action,
            '">',
            data,
            '</a>'
        ].join(' ');
        return link;
    }
    function nameCellRenderer(row) {
        let tooltip = 'Edit Team';
        let action = 'vm.editTeam(data)';
        return createLink(row.data.Name, tooltip, action);
    }
    function actionCellRenderer(row) {
        // projects remvoed until it's decided if this functionality is required or not
        // See https://helpdesk.clear2pay.com/helpdesk/browse/OTSUTP-2956
        return '<div class="ag-grid-actions-container">' + editButton(row) + membersButton(row) + deleteButton(row) + '</div>'; // + projectsButton(row);
    }
    function editButton(row) {
        return "<button class=\"btn btn-xs btn-info glyphicon glyphicon-pencil\" \n  uib-popover=\"Edit Team\" popover-animation  popover-trigger=\"'mouseenter'\" popover-placement=\"left\" popover-append-to-body=\"true\"   ng-click=\"vm.editTeam(data)\"></button>";
    }
    function deleteButton(row) {
        return "<button class=\"btn btn-xs btn-info glyphicon glyphicon-trash\" \n   uib-popover=\"Delete Team\" popover-animation  popover-trigger=\"'mouseenter'\" popover-placement=\"left\" popover-append-to-body=\"true\" ng-click=\"vm.deleteTeam(data)\"></button>";
    }
    function membersButton(row) {
        return "<button class=\"btn btn-xs btn-info\" \n   uib-popover=\"Assign Members\" popover-animation  popover-trigger=\"'mouseenter'\" popover-placement=\"left\" popover-append-to-body=\"true\" ng-click=\"vm.editMembers(data)\"><span class=\"fa fa-user-plus \"/></button>";
    }
    function projectsButton(row) {
        return "<button class=\"btn btn-xs btn-info\" \n   uib-popover=\"Edit Projects\" popover-animation  popover-trigger=\"'mouseenter'\" popover-placement=\"left\" popover-append-to-body=\"true\" ng-click=\"vm.editProjects(data)\"><span class=\"fa fa-users \"/></button>";
    }
    return {
        columnDefs: columnDefs
    };
});
class TeamAdminController {
    constructor($window, $uibModal, UserDetailsApi, TeamServiceApi, ProjectTesterServiceApi, TeamTestProjectServiceApi, ProjectTestingServiceApi, TeamAdminColumnDefs, ModalService, toastr) {
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            this.rowCount = 0;
            this.state = {
                userDetails: {},
                selectedTeam: {},
                showTesters: false,
                showMembers: false,
                showProjects: false,
                linkFromName: true
            };
            this.data = {
                teams: [],
                teamMembers: [],
                projects: []
            };
            this.teamGridOptions = {
                defaultColDef: {
                    resizable: true,
                    sortable: true,
                    filter: true
                },
                columnDefs: this.TeamAdminColumnDefs.columnDefs,
                rowSelection: 'single',
                angularCompileRows: true,
                onSelectionChanged: this.onTeamSelectionChanged,
                onModelUpdated: this.onModelUpdated
            };
            this.UserDetails.get().then((response) => {
                this.state.userDetails = response;
                this.renderTeams();
            });
        };
        this.onModelUpdated = () => {
            let model = this.teamGridOptions.api.getModel();
            let processedRows = model.getRowCount();
            this.rowCount = processedRows;
        };
        this.onTeamSelectionChanged = () => {
            // NOTE: We only allow single row selection
            let selectedRows = this.teamGridOptions.api.getSelectedRows();
            let team = selectedRows[0];
            if (team !== undefined) {
                this.state.selectedTeam = team;
            }
            this.renderTeamMembers(this.state.selectedTeam);
            this.renderTeamProjects(this.state.selectedTeam.Id);
        };
        this.addTeam = () => {
            let team = { Id: 0, Name: '' };
            this.editTeam(team);
        };
        this.editTeam = (team) => {
            this.state.selectedTeam = team;
            let modalInstance = this.uibModal.open({
                backdrop: 'static',
                animation: true,
                component: 'editTeamModal',
                size: 'sm',
                resolve: {
                    team: () => {
                        return team;
                    }
                }
            });
            modalInstance.result.then((team) => {
                this.renderTeams();
                let modalAction = this.state.selectedTeam.Id > 0 ? 'updated' : 'added';
                this.state.selectedTeam = team;
                let msg = [
                    'Team ',
                    team.Name,
                    ' has been ',
                    modalAction,
                    '!'
                ].join('');
                this.toastr.info(msg);
                return;
            }, () => {
                return;
            });
        };
        this.editMembers = (team) => {
            this.state.selectedTeam = team;
            let modalInstance = this.uibModal.open({
                backdrop: 'static',
                animation: true,
                component: 'editSupportModal',
                size: 'sm',
                resolve: {
                    team: () => {
                        return team;
                    }
                }
            });
            modalInstance.result.then(() => {
                this.renderTeams();
                return;
            }, () => {
                return;
            });
        };
        this.editProjects = (team) => {
            this.state.selectedTeam = team;
            let modalInstance = this.uibModal.open({
                backdrop: 'static',
                animation: true,
                component: 'editMembersModal',
                size: 'md',
                resolve: {
                    team: () => {
                        return team;
                    }
                }
            });
            modalInstance.result.then(() => {
                this.renderTeams();
                return;
            }, () => {
                return;
            });
        };
        this.deleteTeam = (team) => {
            let modalOptions = {
                backdrop: 'static',
                actionButtonText: 'OK',
                closeButtonText: 'Cancel',
                headerText: 'Delete Team',
                bodyText: 'Are you sure you want to delete the team ' + team.Name + ' ?'
            };
            this.ModalService.showModal({}, modalOptions).then(() => {
                this.TeamService.deleteTeam(team.Id).then(() => {
                    this.renderTeams();
                    let msg = [
                        'Team ',
                        team.Name,
                        ' has been deleted!'
                    ].join('');
                    this.toastr.info(msg);
                });
            });
        };
        this.renderTeamMembers = (team) => {
            this.state.showMembers = true;
            this.data.teamMembers = team.SupportUsers;
        };
        this.renderTeamProjects = (teamId) => {
            this.state.showProjects = true;
            this.ProjectTestingServiceApi.getAllTeamProjects(teamId).then((response) => {
                this.data.projects = response.data;
                if (this.data.projects.length === 0) {
                    this.data.projects = [];
                    return;
                }
            });
        };
        this.selectTeam = (team) => {
            this.teamGridOptions.api.forEachNode((node) => {
                if (node.data.Id === team.Id) {
                    node.setSelected(true);
                }
                else {
                    node.setSelected(false);
                }
            });
        };
        this.renderTeams = () => {
            this.TeamService.teams().then((response) => {
                let data = response.data;
                this.data.teams = data;
                this.teamGridOptions.api.setRowData(data);
                this.teamGridOptions.api.sizeColumnsToFit();
                if (this.state.selectedTeam.Id === undefined) {
                    this.state.selectedTeam = this.data.teams[0];
                }
                this.selectTeam(this.state.selectedTeam);
            });
        };
        this.window = $window;
        this.uibModal = $uibModal;
        this.ModalService = ModalService;
        this.toastr = toastr;
        this.TeamService = TeamServiceApi;
        this.ProjectTesterService = ProjectTesterServiceApi;
        this.UserDetails = UserDetailsApi;
        this.TeamTestProjectService = TeamTestProjectServiceApi;
        this.TeamAdminColumnDefs = TeamAdminColumnDefs;
        this.ProjectTestingServiceApi = ProjectTestingServiceApi;
    }
}
angular.module('app').component('teamAdmin', {
    bindings: {},
    templateUrl: 'scripts/app/partials/TeamAdmin/team-admin.tpl.html',
    controllerAs: 'vm',
    controller: TeamAdminController
});
